import React from 'react'
import './TextContent.scss'
import { Link } from 'react-router-dom'
import { NAVIGATE_TO } from '../../constants/FileConstants';

export const TextContent = ({ header, description }) => {
    return (
        <div className='text-content-container'>
            <span>
                <h2 className="section-title" dangerouslySetInnerHTML={{ __html: header }} />
            </span>
            <div>
                <p className="paragraph" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        </div>
    );
}
